import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

type GetTenantAttributesReturnType = {
	shard: string | null;
	region: string | null;
	isFedRamp: boolean;
};

export const getTenantAttributes: () => GetTenantAttributesReturnType = () => {
	const shard = getMeta('ajs-shard');
	const region = getMeta('ajs-region');

	return {
		shard,
		region,
		isFedRamp: isFedRamp(),
	};
};
